import { ALLOWED } from "@/app/infrastructures/misc/RolePermission";
import { FlagsPermissionCariSTT } from '@/feature-flags/flags-permission-cari-stt';

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const CariStt = () =>
  import(
    /* webpackChunkName: "CariSTT" */ "@/app/ui/views/dashboard/component/console/cari-stt/index.vue"
  );
const ScanCariStt = () =>
  import(
    /* webpackChunkName: "CariSTT" */ "@/app/ui/views/dashboard/component/console/cari-stt/page-scan-cari-stt/index.vue"
  );

export default [
  {
    path: "/cari-stt",
    component: Layout,
    name: "cari-stt-list",
    meta: {
      header: true,
      icon: "cari-stt",
      children: false,
      title: "Cari STT",
      name: "Cari STT",
      customName: "Manifest cari STT",
      permission: FlagsPermissionCariSTT.permission_cari_stt_list_enabled
    },
    children: [
      {
        path: "/cari-stt",
        name: "cari-stt-list",
        component: CariStt,
        meta: {
          header: true
        }
      }
    ]
  },
  {
    path: "/cari-stt",
    component: Layout,
    name: "cari-stt-scan",
    meta: {
      hidden: true,
      parent: "Manifest cari STT",
      permission: FlagsPermissionCariSTT.permission_cari_stt_scan_enabled
    },
    children: [
      {
        path: "scan",
        name: "cari-stt-scan",
        component: ScanCariStt,
        meta: {
          header: true,
          title: "Manifest cari STT | Scan",
          name: "Cari STT",
          before: "/cari-stt"
        }
      }
    ]
  }
];
  